// BackButton.js
import React from 'react';

const BackButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="bg-subMain hover:bg-subMain text-text font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline-main"
    >
      <svg
        className="h-5 w-5 mr-2 inline-block"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M10 19l-7-7m0 0l7-7m-7 7h18"
        />
      </svg>
    </button>
  );
};

export default BackButton;
